if (!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();

      // Section or context wrapper
      this.mainProduct = this.closest('main-product');
      // Select the product form
      this.productForm = this.closest('product-form');
      this.VariantDrawer = this.querySelector('[data-collapsible-group]');

      // Run on init
      this.getVariantData();
      this.getCurrentVariantId();
      this.setCurrentVariant();

      // Listen for change event
      this.addEventListener('change', this.onVariantChange);

      // Catch click on variant label
      this.variantLabels = this.querySelectorAll('[data-variant="label"]');
      this.variantLabels.forEach((variantLabel) => {
        variantLabel.addEventListener('click', () => {
          this.closeVariantDrawer();
        });
      });

      // Catch click on Add to Cart buttons
      this.variantAddToCartButtons = this.querySelectorAll('[data-variant="add-to-cart"]');
      this.variantAddToCartButtons.forEach((addToCartButton) => {
        addToCartButton.addEventListener('click', (event) => {
          this.handleAddToCart(event);
        });
      });

      // Catch click on BackInStock buttons to trigger the Klaviyo form
      this.variantBackInStockButtons = this.querySelectorAll('[data-backinstock]');
      this.variantBackInStockButtons.forEach((backInStockButton) => {
        backInStockButton.addEventListener('click', (event) => {
          // Check if Klaviyo is loaded and trigger the click, else follow the link to go to the PDP and trigger the Klaviyo BIS form there
          if (window.checkKlaviyoAndTriggerClick) {
            event.preventDefault();
            window.checkKlaviyoAndTriggerClick();
          }
          this.closeVariantDrawer();
        });
      });
    }

    /**
     * handleAddToCart
     * @description Adds the product variant directly to the cart
     * @param {Object} event
     */
    async handleAddToCart(event) {
      const button = event.currentTarget;
      button.classList.add('loading');
      // Set this and other buttons disabled in the list disabled
      this.variantAddToCartButtons.forEach((addToCartButton) => {
        addToCartButton.setAttribute('disabled', true);
      });

      // Select variant
      const variant = button.closest('[data-variant="item"]');
      const variantInput = variant.querySelector('input[name="id"]');
      variantInput.setAttribute('checked', true);
      variantInput.checked = true;

      // Wait till all the change stuff is done
      await this.onVariantChange();

      // Now add it to the cart
      const submit = this.productForm.querySelector('[type="submit"]');
      submit.click();
      this.closeVariantDrawer();
      button.classList.remove('loading');
      this.variantAddToCartButtons.forEach((addToCartButton) => {
        // Skip when button was already disabled
        if (addToCartButton.dataset.disabled === 'true') return;
        // Enable button
        addToCartButton.removeAttribute('disabled');
      });

      // Now again for the Klaviyo button
      const eventChange = new Event('change', { bubbles: true });
      variantInput.dispatchEvent(eventChange);
    }

    /**
     * onVariantChange
     * @description Listen on variant change event.
     * @param {Object} event
     */
    async onVariantChange() {
      this.getCurrentVariantId();
      this.setCurrentVariant();
      this.updateVariantTitle();
      this.toggleAddToCartButton(true, '', false);

      this.dispatchEvent(
        new CustomEvent('variant-change', {
          bubbles: true,
          variant: this.currentVariant,
          detail: {
            variant: this.currentVariant,
          },
        })
      );

      // Now check if we are on the real pdp? If so update content.
      if (window.location.pathname === this.dataset.url) {
        this.updateMedia();
        this.updateURL();
      }

      const html = await this.renderProductInfo();
      this.updatePrice(html);
      this.updateProperties(html);
      this.updateQuantity(html);
      this.updateDiscountGroup(html);
      this.updateInventoryQuantity(html);
      this.updateInventoryStatus(html);
      this.updateSKU(html);
      this.updateAddToCartButton(!this.currentVariant.available, window.variantStrings.soldOut);
      this.dispatchVariantChange();
    }

    getCurrentVariantId() {
      // debugger;
      const options = this.querySelectorAll('input[name="id"]');
      this.options = [...options];
      const activeRadio = this.options.filter((input) => {
        if (input.checked) {
          return input;
        }
      })[0];
      if (!activeRadio) return;
      this.currentVariantId = parseInt(activeRadio.value);
    }

    setCurrentVariant() {
      this.currentVariant = this.variantData.variants.filter((variant) => {
        if (variant.id === this.currentVariantId) {
          return variant;
        }
      })[0];
    }

    /**
     * dispatchVariantChange
     * @description Pushes the selected variant data in event.
     * @returns {Void}
     */
    dispatchVariantChange() {
      document.dispatchEvent(
        new CustomEvent('variant-change', {
          bubbles: true,
          variant: this.currentVariant,
          detail: {
            variant: this.currentVariant,
          },
        })
      );
    }

    /**
     * updateMedia
     * @returns {Void}
     */
    updateMedia() {
      if (!this.currentVariant || !this.currentVariant?.featured_media) return;
      const newMedia = this.mainProduct.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
      if (!newMedia) return;
      const parent = newMedia.parentElement;
      parent.prepend(newMedia);
      window.setTimeout(() => {
        parent.scroll(0, 0);
      });
    }

    /**
     * updateURL
     * @description Sets the variant id in the url.
     * @returns {Void}
     */
    updateURL() {
      if (!this.currentVariant) return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    /**
     * toggleAddToCartButton
     * @description
     * @param {Boolean} disable
     * @param {String} text
     * @param {Boolean} modifyClass
     * @returns {void}
     */
    toggleAddToCartButton(disable = true, text, modifyClass = true) {
      const addButton = this.productForm.querySelector('[name="add"]');
      const addButtonText = addButton.querySelector('[data-add-to-cart-button-text]');

      if (!addButton || !addButtonText) return;

      if (disable) {
        addButton.setAttribute('disabled', true);
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    }

    /**
     * getVariantData
     * @returns {Void}
     */
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      // if there is custom availability data
      if (this.variantData.variantsAvailability) {
        // loop through all variants
        this.variantData.variants.forEach((variant, index) => {
          // if there is custom availability data for this variant
          if (this.variantData.variantsAvailability[variant.id] != null) {
            // set the availability to the custom value
            this.variantData.variants[index].available = this.variantData.variantsAvailability[variant.id];
          }
        });
      }
      return this.variantData;
    }

    /**
     * closeVariantDrawer
     * @description Closes the slide out panel after selecting the option.
     * @returns {Void}
     */
    closeVariantDrawer() {
      this.VariantDrawer.classList.remove('collapsible-is-open');
    }

    /**
     * updateVariantTitle
     * @description Sets the option1, 2 and 3 titles after selecting one.
     * @returns {Void}
     */
    updateVariantTitle() {
      // Get title from option group
      const title = this.querySelector(`[data-variant-title]`);
      // Set the correct option name
      title.textContent = this.currentVariant.title;
    }

    /**
     * updatePrice
     * @description Update the main product price.
     * @param {Node} html
     * @returns {Void}
     */
    updatePrice(html) {
      const selector = `[data-main-product-price]`;
      const destination = this.mainProduct.querySelector(selector);
      const source = html.querySelector(selector);
      if (source && destination && destination.innerHTML != source.innerHTML) {
        destination.innerHTML = source.innerHTML;
        window?.loyaltylion?.ui?.refresh?.();
      }
    }

    /**
     * updateQuantity
     * @description Update the quantity selector.
     * @param {Node} html
     * @returns {Void}
     */
    updateQuantity(html) {
      const selector = `[data-product-form-quantity]`;
      const destination = this.mainProduct.querySelector(selector);
      const source = html.querySelector(selector);
      if (source && destination && destination.innerHTML != source.innerHTML) destination.innerHTML = source.innerHTML;
    }

    /**
     * updateProperties
     * @description Update the main product price.
     * @param {Node} html
     * @returns {Void}
     */
    updateProperties(html) {
      const source = html.querySelector(`[data-update-variant-properties]`);
      if (!source || !source.dataset.updateVariantProperties) return;
      const updateProperties = JSON.parse(source.dataset.updateVariantProperties);
      // Update all line_item properties
      Object.entries(updateProperties).forEach(([k, v]) => {
        this.mainProduct.querySelector(`input[name="${k}"]`).value = v;
      });
    }

    /**
     * updateDiscountGroup
     * @description Update the main product discount group.
     * @param {Node} html
     * @returns {Void}
     */
    updateDiscountGroup(html) {
      const selector = '[data-main-product-member]';
      const destination = this.mainProduct.querySelector(selector);
      const source = html.querySelector(selector);
      if (source && destination && destination.innerHTML != source.innerHTML) destination.innerHTML = source.innerHTML;
    }

    /**
     * updateInventoryQuantity
     * @description Update the main product inventory quantity.
     * @param {Node} html
     * @returns {Void}
     */
    updateInventoryQuantity(html) {
      // Update the inventory quantity hidden input
      const inventoryQtyDestination = this.mainProduct.querySelector(`product-form`).querySelector('input[name="inventory_quantity"]');
      const inventoryQtySource = html.querySelector(`product-form`).querySelector('input[name="inventory_quantity"]');
      if (inventoryQtyDestination && inventoryQtySource) {
        inventoryQtyDestination.value = inventoryQtySource.value;
      }
    }

    /**
     * updateInventoryStatus
     * @description Update all main product inventory statuses.
     * @param {Node} html
     */
    updateInventoryStatus(html) {
      let selector = '[data-main-product-inventory-status]';
      let destinations = this.mainProduct.querySelectorAll(selector);
      if (document.querySelector('#set-products')) {
        selector = '.inventory-quantity[data-main-product-inventory-status]';
        destinations = this.mainProduct.querySelectorAll(selector);
      }
      const sources = Array.from(html.querySelectorAll(selector));
      if (destinations.length && sources.length) {
        destinations.forEach((destination, index) => {
          destination.innerHTML = sources[index].innerHTML;
        });
      }
    }

    /**
     * updateSKU
     * @description Update all sku's.
     * @param {Node} html
     */
    updateSKU(html) {
      const selector = '[data-main-product-sku]';
      const destinations = this.mainProduct.querySelectorAll(selector);
      const sources = Array.from(html.querySelectorAll(selector));
      if (destinations.length && sources.length) {
        destinations.forEach((destination, index) => {
          destination.innerHTML = sources[index].innerHTML;
        });
      }
    }

    /**
     * updateAddToCartButton
     * @description
     * @param {Boolean} disable
     * @param {String} text
     * @param {Boolean} modifyClass
     * @returns {void}
     */
    updateAddToCartButton(disable = true, text, modifyClass = true) {
      const addButton = this.mainProduct.querySelector(`product-form`)?.querySelector('[name="add"]');
      const addButtonText = addButton.querySelector('[data-add-to-cart-button-text]');

      // Custom Klaviyo BackInStock button, only rendered on set products
      const bisButton = this.mainProduct.querySelector(`product-form`)?.querySelector('[data-bis]');

      if (!addButton || !addButtonText) return;

      if (disable) {
        addButton.setAttribute('disabled', true);
        if (text) addButtonText.textContent = text;
        if (bisButton) {
          bisButton.classList.remove('hidden');
          bisButton.href = this.variantData.product.url + `?variant=${this.currentVariant.id}&view=backInStock`;
          addButton.classList.add('hidden');
        }
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
        if (bisButton) {
          bisButton.classList.add('hidden');
          bisButton.href = this.variantData.product.url + `?variant=${this.currentVariant.id}&view=backInStock`;
          addButton.classList.remove('hidden');
        }
      }

      if (!modifyClass) return;
    }

    /**
     * renderProductInfo
     * @description Fetches the product page with the selected variant id and refreshes the UI.
     * @returns {Void}
     */
    async renderProductInfo() {
      try {
        const url = `${this.dataset.url}?variant=${this.currentVariant.id}&view=ajax`;
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        return html;
      } catch (error) {
        console.log(error);
      }
    }
  }
  customElements.define('product-variants', ProductVariants);
}
